import { SemanticColorKey } from 'app/components/v2/theme/colors';

// Local Variables
const csrfMetaTagName = 'csrf_token';

export function findParentElementByClassName(el: Element | null, className: string) {
  if (!el) {
    return null;
  }

  let element = el;

  while (element.parentElement) {
    element = element.parentElement;

    if (element.classList.contains(className)) {
      return element;
    }
  }

  return null;
}

export function setCsrf(csrfToken: string) {
  const headTag = document.querySelector('head');
  const metaTag = document.querySelector(`meta[name="${csrfMetaTagName}"]`);

  if (metaTag) {
    metaTag.setAttribute('content',
      csrfToken);
  } else {
    const newMetaTag = document.createElement('meta');
    newMetaTag.setAttribute('name',
      csrfMetaTagName);
    newMetaTag.setAttribute('content',
      csrfToken);

    headTag?.appendChild(newMetaTag);
  }
}

export function removeCsrf() {
  const headTag = document.querySelector('head');
  const meta = document.querySelector(`meta[name="${csrfMetaTagName}"]`);

  if (meta) {
    headTag?.removeChild(meta);
  }
}

// this function will recursively get the value of a CSS variable
// this function should not be exported outside of this file
// if you need to use it, create a new function that calls this one
const getCssVarValueRecursive = (key: string): string => {
  const value = getComputedStyle(document.documentElement).getPropertyValue(key);
  if (value.startsWith('var(')) {
    const variableName = value.slice(4, -1);

    return getCssVarValueRecursive(variableName).trim();
  }

  return value.trim();
};

// recursively get the value of a CSS variable
export const getComputedColor = (colorVariableKey: SemanticColorKey): string => {
  return getCssVarValueRecursive(`--color-${colorVariableKey}`);
};
